import { createContext, useContext } from 'react';

export interface FacilityContextType {
    facilityDetails: any;
    facilityTimezone: string;
    loading: boolean;
    refresh: () => Promise<void>;
}

const initialFacilityContext: FacilityContextType = {
    facilityDetails: null,
    facilityTimezone: '',
    loading: true,
    refresh: () => Promise.resolve(),
};

// Create the context with initial values
export const FacilityContext = createContext<FacilityContextType>(initialFacilityContext);

// Custom hook to use the facility context
export const useFacility = (): FacilityContextType => useContext(FacilityContext);